import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import english from './../../../i18n/en.json';
import spanish from './../../../i18n/es.json';
import portuguese from './../../../i18n/pt.json';
var TabLocationsGroupsComponent = /** @class */ (function () {
    function TabLocationsGroupsComponent(data, fuseTranslationLoaderService, formBuilder) {
        this.data = data;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.formBuilder = formBuilder;
        this.getLocationGroupForm = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.locationGroup = this.data.locationGroup;
        this.locationGroupForm = this.formBuilder.group({
            name: [this.locationGroup.name, [Validators.required, Validators.maxLength(100)]],
            description: this.locationGroup.description
        });
        if (this.data.isViewMode) {
            this.locationGroupForm.disable();
        }
    }
    TabLocationsGroupsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.locationGroupForm.valueChanges.subscribe(function () { return _this.getLocationGroupForm.next(_this.locationGroupForm); });
        this.getLocationGroupForm.next(this.locationGroupForm);
    };
    return TabLocationsGroupsComponent;
}());
export { TabLocationsGroupsComponent };
